import { ProjectRenderer } from './ProjectRenderer';
import { SerializedRenderer } from './types';
import APP_CONFIG from '@/configs/appConfig';

export class HistoryManager {
	private snapshots: SerializedRenderer[] = [];
	private maxSnapshots = APP_CONFIG.HISTORY_MAX_LENGTH;

	constructor(private renderer: ProjectRenderer) {}

	async undo() {
		const lastSnapshot = this.snapshots.pop();
		if (!lastSnapshot) return;

		await this.renderer.collectionBuilder.buildCollection(lastSnapshot);
	}

	addSnapshot() {
		this.snapshots.push(this.renderer.export());
		if (this.snapshots.length > this.maxSnapshots) this.snapshots.shift();
	}
}
